var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-menu-wrap"},[_c('el-menu',{staticClass:"channel-menu",attrs:{"default-active":_vm.currIndex,"mode":"horizontal"},on:{"select":_vm.handleMenuSelect}},_vm._l((_vm.subChannelList),function(item){return _c('el-menu-item',{key:item.channelId,attrs:{"index":item.alias}},[_vm._v(_vm._s(item.name)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }